document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-legacy-section]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-legacy-track]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    items.forEach((item) => {
      track.appendChild(item.cloneNode(true));
    });

    window.addEventListener('load', () => {
      const halfTrackWidth = track.scrollWidth / 2;
      const duration = Math.max(13.5, halfTrackWidth / 100);
      section.style.setProperty('--legacy-scroll-duration', `${duration}s`);
    }, { once: true });
  });
});
